export default __webpack_public_path__ + "static/media/Background_00291.a05e0bd7.png";